import React from "react";

export default function StateGuard({ loading, error, empty, emptyMessage, children }) {
  if (loading) return <div className="diagoeau-state-msg">Chargement…</div>;
  if (error) return <div className="diagoeau-state-msg diagoeau-error">{error}</div>;
  if (empty)
    return (
      <div className="diagoeau-state-msg">
        {emptyMessage || "Pas de données pour cette sélection."}
      </div>
    );
  return children;
}
